import { ROUTE_PATH } from "common/constants/sm-constants";
import { MetaModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";
import { InternshipFilterMetaModel } from "./internship-report-filter-meta.model";

export class InternshipReportsGridMetaModel extends GridMetaModel<Headers> {
    filterMeta = new InternshipFilterMetaModel().getMetaModel();
    constructor() {
        super(
            'Internship Reports',
            ROUTE_PATH.reports,
            ROUTE_PATH.reports,
            false,
            false,
            8,
            false,
            false,
            ['orgname'],
            false,
            [],
            { isDownloadExcel: true, excelFileName: 'Internship Reports_' + new Date().toLocaleDateString() +'.xlsx', btnLabel: 'Download Internship Report', headers: [{ key: 'StudentName', value: 'orgname' }, { key: 'CollegeName', value: 'name_of_college' }, { key: 'Branch', value: 'branchName' }, { key: 'Internship Company', value: 'companyName' }, { key: 'Location', value: 'locName' }, { key: 'Internship Start Date', value: 'startDate' }, { key: 'Internship End Date', value: 'endDate' }, { key: 'Mentor', value: 'mentorName' }, { key: 'Mentor Department', value: 'mentorDepartment' }, { key: 'Internship Status', value: 'OverallStatus' }] },
            false,
            null,
            false,
            false,
            false,
            null,
            { evalKey: 'isDeletable', evalParam: [1], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            false,
            [],
            false,
            { isExtraActions: false, btnLabel: '' },
            {isCheckboxEmit: false, emitKey: '', checkedKey: '', valueKey: ''},
        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const studentName = new Headers('Student Name', 'orgname', false, false, 'text');
        const collegeName = new Headers('College Name', 'name_of_college', false, false, 'text');
        const branch = new Headers('Branch', 'branchName', false, false, 'text');
        const companyName = new Headers('Internship Company', 'companyName', false, false, 'text');
        const locName = new Headers('Location', 'locName', false, false, 'text');
        const studentExpectedInternshipStartDate = new Headers('Start Date', 'startDate', false, false, 'text');
        const studentExpectedInternshipEndDate = new Headers('End Date', 'endDate', false, false, 'text');
        const mentorName = new Headers('Mentor', 'mentorName', false, false, 'text');
        const mentorDepartment = new Headers('Dept. of Mentor', 'mentorDepartment', false, false, 'text');
        const internshipStatus = new Headers('Internship Status', 'OverallStatus', false, false, 'text')
        headers.push(studentName);
        headers.push(collegeName);
        headers.push(branch);
        headers.push(companyName);
        headers.push(locName);
        headers.push(studentExpectedInternshipStartDate);
        headers.push(studentExpectedInternshipEndDate);
        headers.push(mentorName);
        headers.push(mentorDepartment);
        headers.push(internshipStatus);
        return headers;
    }

    override getMetaModel(): MetaModel {
        const pageData = new MetaModel();
        pageData.pageTitle = this.pageTitle;
        pageData.properties = this.initProperties();
        pageData.redirectPath = this.redirectPath;
        pageData['filterMeta'] = this.filterMeta;
        return pageData;
      }
}